"use client"

import Image from "next/image";
import LeadForm from "@/components/forms/LeadForm";
import PublicBreadcrumb from "@/components/ui/public-breadcrumb";
import { type Locale } from "@/i18n-config";

interface BookFormDict {
    common?: {
        home?: string;
    };
    book_page?: {
        title?: string;
        intro?: string;
        submit?: string;
        image_alt?: string;
    };
    form?: {
        send?: string;
    };
}

export default function BookFormSection({ dict, lang = "tr" }: { dict?: BookFormDict; lang?: Locale }) {
    return (
        <section className="bg-[#0b1d33] py-6 lg:py-8">
            <div className="container-custom">
                <PublicBreadcrumb
                    items={[
                        { label: dict?.common?.home || "Home", href: lang === "tr" ? "/" : `/${lang}` },
                        { label: dict?.book_page?.title || "Book Now" },
                    ]}
                    className="mb-8 lg:mb-10"
                />

                <div className="flex flex-col items-start gap-8 py-12 lg:flex-row lg:gap-12">
                    <div className="relative hidden w-full lg:block lg:w-[52%] xl:w-[56%]">
                        <div className="relative w-full aspect-[16/10] overflow-hidden rounded-2xl shadow-2xl xl:aspect-[16/9]">
                            <Image
                                src="https://cdn.cinikpoliklinigi.com/general/bina.jpg"
                                alt={dict?.book_page?.image_alt || "Cinik Clinic Building"}
                                fill
                                className="object-cover"
                                sizes="(max-width: 1024px) 100vw, (max-width: 1280px) 52vw, 56vw"
                            />
                        </div>
                    </div>

                    <div className="w-full lg:flex-1">
                        <h1 className="mb-4 text-3xl font-bold text-white">{dict?.book_page?.title}</h1>
                        <p className="mb-10 max-w-[600px] text-[15px] leading-relaxed text-[#a5b4c4]">
                            {dict?.book_page?.intro}
                        </p>

                        <div className="max-w-[600px]">
                            <LeadForm dict={dict} submitLabel={dict?.book_page?.submit || dict?.form?.send} idPrefix="book-form" lang={lang} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
